/**
 * Turns a marker's clicks and hover on or off in place. Leaflet reads a marker's `interactive`
 * option only when it draws the icon, and the plugin's spiderfy and the cluster bubbles hide and
 * show markers on their own, so the layers flip the option and the drawn icon together here.
 */
import L from 'leaflet';

/**
 * Off: a click on the marker reaches the map, its tooltip closes and no hover opens it. A marker
 * that is not drawn (inside a cluster) takes the option when it is. Keeps the marker on its layer,
 * so an open spider stays open.
 */
export function setMarkerInteractive(marker: L.Marker, interactive: boolean): void {
  if ((marker.options.interactive ?? true) === interactive) return;
  const el = marker.getElement();
  if (el && !interactive) {
    marker.closeTooltip();
    L.DomUtil.removeClass(el, 'leaflet-interactive');
    marker.removeInteractiveTarget(el);
  }
  marker.options.interactive = interactive;
  if (el && interactive) {
    L.DomUtil.addClass(el, 'leaflet-interactive');
    marker.addInteractiveTarget(el);
  }
}
